import {Component, OnInit, AfterViewInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {CommonService} from '../common.service';
import {ApiService} from '../api.service';

@Component({
  selector: 'app-scorm',
  templateUrl: './app-scorm.component.html',
  styleUrls: ['./app-scorm.component.css'],
})
export class AppScormComponent implements OnInit, AfterViewInit {
  courseId: string;
  version: string;
  courseName: string;
  language = 1;
  projectId: string;
  canClick = true;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private commonService: CommonService,
    private apiService: ApiService) {
  }


  ngOnInit() {
    localStorage.setItem('moduleId', '2');
    this.commonService.removeStorage('language');
    this.initPage();
  }

  initPage() {
    this.route.params.subscribe(params => {
      this.courseId = params.courseId;
    });

    this.route.queryParams.subscribe(query => {
      this.version = query.version;
      this.courseName = query.name;
      this.projectId = query.projectId;
    });

    const token = this.commonService.getStorage('transtalen-token') ;
    const host = window.location.origin.indexOf('localhost') >= 0 ? 'https://m-uat.transtalent.cn' : window.location.origin;
    const playerHost = host === 'https://m-uat.transtalent.cn' ? 'https://oss-uat.transtalent.cn' : 'https://oss-prod.transtalent.cn';
    const scormPlayer = document.getElementById('scormPlayer');
    if (scormPlayer instanceof HTMLIFrameElement) {
      scormPlayer.src = `${playerHost}/scorm/scormPlayer.html?apiDomain=${host}/&token=${token}&courseId=${this.courseId}&language=${this.language}`;
    } else {
      console.error('scormPlayer is not an iframe element');
    }
  }

  goToLearningMap() {
    if (this.canClick) {
      this.canClick = false;
      if (this.projectId) {
        this.router.navigate(['learning-project', this.projectId]).then();
      } else {
        this.router.navigate(['learning-map']).then();
      }
      setTimeout(() => {
        this.canClick = true;
      }, 2000);
    }
  }

  changeLanguage() {
    this.language = Number(this.language) === 1 ? 2 : 1;
    this.initPage();
  }

  ngAfterViewInit() {
    this.commonService.initPage();
  }

}




// WEBPACK FOOTER //
// ./src/app/app-scorm/app-scorm.component.ts